(function () {
  function waitFor(conditionFn, callback, timeout = 8000) {
    const start = Date.now();
    const timer = setInterval(() => {
      if (conditionFn()) {
        clearInterval(timer);
        callback();
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        console.warn('Buy Button timeout');
      }
    }, 100);
  }

  waitFor(
    () =>
      window.ShopifyBuy &&
      window.ShopifyBuy.UI &&
      document.querySelector('.custom-buy-button'),
    initBuyButton
  );

  function initBuyButton() {
    var client = ShopifyBuy.buildClient({
      domain: 'belfastsinks.myshopify.com',
      storefrontAccessToken: '187bd297079d923c4ab8c8cf17ca41d5',
    });

    ShopifyBuy.UI.onReady(client).then(function (ui) {
      document.querySelectorAll('.custom-buy-button').forEach(function (el) {
        if (el.dataset.loaded) return; // prevent duplicates

        ui.createComponent('product', {
          id: el.dataset.productId,
          node: el,
          options: {
            product: {
              buttonDestination: 'checkout',
              text: {
                button: 'Buy now',
              },
            },
          },
        });

        el.dataset.loaded = 'true';
      });
    });
  }
})();
